// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14_fX","left":"styles_left__2UswF"};